import { useEffect } from 'react';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import "../user-details.css";

const StatusModal = ({ showStatusModal, statusMessage, statusSuccess, handleStatusModalClose }) => {    

    return (
        <div className="status-modal-container"
            style={{ display: 'block', position: 'initial' }} >
            <Modal show={showStatusModal} dialogClassName="modal-status-message" centered>            
                <Modal.Body>
                    <div className="row status-modal-icon">
                        <div className="col">
                            {statusSuccess && <img className="img-icon" src="images/icons8checkcolor96.png" height="96" />}
                            {!statusSuccess && <img className="img-icon" src="images/icons8crosscolor96.png" height="96" />}
                        </div>
                    </div>
                    <div className="row status-modal-message">
                        <div className="col">
                            {statusMessage}
                        </div>
                        
                    </div>
                    <div className="row">
                        <div className="col">
                            <Button className="status-modal-ok" variant="primary"
                                onClick={handleStatusModalClose}
                            >Ok</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}
    

export default StatusModal;